exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button_class[data-v-4c3fe8b8]{-webkit-box-flex:1;-ms-flex:1;flex:1;display:inline-block;text-align:center;padding:15px 0;font-size:14px}.button_hover_class[data-v-4c3fe8b8]{opacity:.1}", ""]);

// exports
